import * as React from 'react';

interface IProps {
  comment: string
  commentCategory: string
  commentType: string
}

export function WellComponent(props: IProps) {
  const {comment, commentType, commentCategory} = props;
  return (
    <div className={`well ${commentCategory.toLowerCase()}`}>
      <span className="short-label">
        {commentType}
        <span className="clear-button">
          <a onClick={() => {
              // @ts-ignore
              window.removeComment();
            }}
          >
            Clear
          </a>
        </span>
        <br></br>{' '}
        <span className="comment">
          {comment}
        </span>
      </span>
    </div>
  );
};
